import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { CUSTOM_TERM_KEY } from '../../../../../../../../../../common/functions/getLoanTermOptions';
import { ItemRow } from '../../../../ItemRow/ItemRow';
import { TermDropDownField } from './components/TermDropDownField';
import { InitialTermMonthsField } from './components/InitialTermMonthsField';
import { ContractualExtension1MonthsField } from './components/ContractualExtension1MonthsField';
import { ContractualExtension2MonthsField } from './components/ContractualExtension2MonthsField';

/** The loan term: the term dropdown, plus (for a Custom term) the initial term and extension months on one row. */
export const TermInfo = () => {
    const selectedTermKey = useStandardLoanStore((state) => state.selectedTermKey);

    return (
        <>
            <ItemRow>
                <TermDropDownField />
            </ItemRow>
            {/* A Custom term's three month fields share one row. */}
            {selectedTermKey === CUSTOM_TERM_KEY && (
                <ItemRow>
                    <InitialTermMonthsField />
                    <ContractualExtension1MonthsField />
                    <ContractualExtension2MonthsField />
                </ItemRow>
            )}
        </>
    );
};
